import { supabase } from "../supabase";

/**
 * 日記のしおり。
 *
 * **各自が自分のぶんだけを持つ**(→ 20260814171946_diary_bookmarks.sql)。
 * RLS が自分の行しか返さないので、問い合わせ側で誰のものかを指定する必要はない。
 */
export async function fetchBookmarkedEntryIds(): Promise<Set<string>> {
  const { data, error } = await supabase.from("diary_bookmarks").select("entry_id");
  if (error) throw error;
  const rows: { entry_id: string }[] = data;
  return new Set(rows.map((row) => row.entry_id));
}

/** 既に挟んでいれば黙って飛ばす。user_id は DB 側の既定値で auth.uid() が入る */
export async function addBookmark(entryId: string): Promise<void> {
  const { error } = await supabase
    .from("diary_bookmarks")
    .upsert({ entry_id: entryId }, { onConflict: "entry_id,user_id", ignoreDuplicates: true });
  if (error) throw error;
}

export async function removeBookmark(entryId: string): Promise<void> {
  const { error } = await supabase.from("diary_bookmarks").delete().eq("entry_id", entryId);
  if (error) throw error;
}

function isEntryIdRow(value: unknown): value is { entry_id: string } {
  if (typeof value !== "object" || value === null) return false;
  return typeof (value as Record<string, unknown>).entry_id === "string";
}

/**
 * 「二人のベストセレクション」用。両方がしおりを挟んだエントリーIDだけを返す。
 * 誰が挟んだかは開示しない(RPC 側で definer 関数として集計だけ返す)ので、
 * 相手個人のしおり一覧を見せる方式より非公開の方針を崩さずに済む。
 *
 * DBの型を生成していないので rpc の戻りは any になる。型注釈で覆うと実態と
 * 食い違ったときに気づけないため、実行時に検証する(→ media/timeline.ts の
 * fetchMonthCounts と同じ組み立て方)。
 */
export async function fetchMutualBookmarkedEntryIds(): Promise<Set<string>> {
  const response = await supabase.rpc("diary_mutual_bookmark_entry_ids");
  if (response.error) throw response.error;

  const rows: unknown = response.data;
  if (!Array.isArray(rows)) return new Set();

  return new Set(rows.filter(isEntryIdRow).map((row) => row.entry_id));
}
